import { useAppContext } from 'src/contexts/AppContext';
import { Feature } from 'src/WebApiController';

import { useUserHasFeature } from './useUserHasFeature';

export const useUserHasConsignorMasterUI = () => {
  const { loginContext } = useAppContext();

  const hasEnableMasterUiViewForConsignorsFeature = useUserHasFeature(
    Feature.EnableMasterUiViewForConsignors
  );

  return Boolean(
    loginContext?.user?.activeAccount.isConsignor &&
      hasEnableMasterUiViewForConsignorsFeature
  );
};

export const useUserHasConsignorMasterUIForUserManagement = () => {
  const hasConsignorMasterUI = useUserHasConsignorMasterUI();

  const hasUserManagementMasterUiForConsignorFeature = useUserHasFeature(
    Feature.UserManagementMasterUiForConsignor
  );

  return hasConsignorMasterUI && hasUserManagementMasterUiForConsignorFeature;
};
